import React, { Component } from "react";
import "../index.scss";
import MailIcon from "../icons/mail_email.svg";
import KeyIcon from "../icons/key.svg";
import OtpInput from "react-otp-input";
import Message from "../message";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import { connect } from "react-redux";
import { signInFromOTP } from "../../../store/actions/authActionFromOTP";
import RightIcon from "../icons/rightIcon.svg";
import Timer from "../timer";
class SubmitOTP extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: "",
      isProcessing: false,
      message: {
        text: props.otpInfo?.message,
        color: "#f73e8f",
      },
      showResend: false,
    };
  }

  changeOTP = (e) => {
    this.setState({ otp: e });
  };

  submitOTP = () => {
    this.setState({ isProcessing: true });
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/auth/validate-otp`, {
        user_id: this.props.otpInfo.user_id,
        user_otp: this.state.otp,
      })
      .then((res) => {
        this.props.signInFromOTP(res);
      })
      .catch((err) => {
        this.setState({ isProcessing: false });
        console.log("something went wrong");
        if (err.response.data)
          this.setState({
            message: {
              text: err.response.data.message,
              color: "red",
            },
          });
        else
          this.setState({
            message: {
              text: "Something went wrong",
              color: "red",
            },
          });
      });
  };

  resendOTP = () => {
    this.setState({ isProcessing: true });
    axios
      .post(`${process.env.REACT_APP_API_URL}/api/auth/resend-otp`, {
        user_id: this.props.otpInfo.user_id,
      })
      .then((res) => {
        this.setState({
          showResend: false,
          isProcessing: false,
          message: { text: res.data.message, color: "#f73e8f" },
        });
      })
      .catch((err) => {
        this.setState({ isProcessing: false });
        if (err.response.data)
          this.setState({
            message: {
              text: err.response.data.message,
              color: "red",
            },
          });
        else
          this.setState({
            message: {
              text: "Something went wrong",
              color: "red",
            },
          });
      });
  };

  callBackFromTimer = () => {
    this.setState({ showResend: true, message: null, otp: "" });
  };

  handleKeyDown = (e) => {
    if (
      e.key === "Enter" &&
      this.state.otp.length === 5 &&
      !this.state.showResend &&
      !this.state.isProcessing
    ) {
      this.submitOTP();
    }
  };

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  render() {
    const _OTP_LENGTH = 5;
    return (
      <div className="otp-container">
        <div className="otp-header-container">
          <h2>Login</h2>
          <h3>Please login to your account</h3>
        </div>

        <div
          className="otp-input auth-input-fields "
          style={{
            filter: this.state.showResend ? "blur(2px)" : "blur(0px)",
          }}
        >
          <OtpInput
            value={this.state.otp}
            onChange={this.changeOTP}
            numInputs={_OTP_LENGTH}
            renderSeparator={<span>-</span>}
            shouldAutoFocus={true}
            renderInput={(props) => (
              <input {...props} disabled={this.state.showResend} />
            )}
          />

          {
            <Message
              msg={this.state.message?.text}
              color={this.state.message?.color}
            />
          }
        </div>
        <div className="auth-button-container">
          {!this.state.showResend && (
            <Timer callBack={this.callBackFromTimer} />
          )}
          {this.state.showResend ? (
            <button
              className="auth-action-button resend-otp"
              onClick={this.resendOTP}
            >
              {this.state.isProcessing ? (
                <CircularProgress color="white" size={20} />
              ) : (
                <>
                  Resend OTP
                  <img src={RightIcon} />
                </>
              )}
            </button>
          ) : (
            <button
              className="auth-action-button"
              disabled={this.state.otp.length !== _OTP_LENGTH}
              onClick={this.submitOTP}
            >
              {this.state.isProcessing ? (
                <CircularProgress color="white" size={20} />
              ) : (
                "Login"
              )}
            </button>
          )}
          {/* <button
            className="auth-action-button"
            disabled={this.state.otp.length !== _OTP_LENGTH}
            onClick={this.submitOTP}
          >
            {this.state.isProcessing ? (
              <CircularProgress color="white" size={20} />
            ) : (
              "Submit OTP"
            )}
          </button> */}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};
const mapDispatchToProps = (dispatch) => {
  return {
    signInFromOTP: (creds, rtoken) => dispatch(signInFromOTP(creds, rtoken)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SubmitOTP);
